import React from 'react';
import styles from './alert.module.css';

function Alert({alert}) {
  return <div className={styles.status} style={{backgroundColor: alert ? 'red' : 'green'}}></div>;
}

export default Alert;
